export enum TipoPessoaDocumentoEnum {
  AMBAS = 'AMBAS',
  FISICA = 'FISICA',
  JURIDICA = 'JURIDICA'
}

export const tipoPessoaDocumentoEnum = {
  AMBAS: 'Ambas',
  FISICA: 'Física',
  JURIDICA: 'Jurídica'
};
